'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

const React = require('react');
const React__default = _interopDefault(React);
const styled = require('styled-components');
const styled__default = _interopDefault(styled);
const skeleton_style = require('./skeleton.style.js');

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var getLoadingClassName = function getLoadingClassName(className, isLoading) {
  var temp = [className];
  if (isLoading) {
    temp.push('is-loading');
  }
  return temp.join(' ');
};
var Skeleton = function Skeleton(_ref) {
  var _ref$height = _ref.height,
    height = _ref$height === void 0 ? '100%' : _ref$height,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? '100%' : _ref$width,
    _ref$borderRadius = _ref.borderRadius,
    borderRadius = _ref$borderRadius === void 0 ? '5px' : _ref$borderRadius,
    _ref$isCircle = _ref.isCircle,
    isCircle = _ref$isCircle === void 0 ? false : _ref$isCircle,
    _ref$animation = _ref.animation,
    animation = _ref$animation === void 0 ? true : _ref$animation,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? {} : _ref$theme,
    isLoading = _ref.isLoading,
    children = _ref.children,
    className = _ref.className,
    _ref$margin = _ref.margin,
    margin = _ref$margin === void 0 ? 5 : _ref$margin,
    _ref$count = _ref.count,
    count = _ref$count === void 0 ? 1 : _ref$count;
  var skeletonArr = [];
  var completeProps = {
    height: height,
    width: width,
    borderRadius: borderRadius,
    animation: animation,
    isCircle: isCircle,
    theme: theme,
    children: children,
    className: className,
    margin: margin,
    count: count,
    isLoading: isLoading
  };
  for (var i = 0; i < count; i++) {
    var skeletonItemId = "skeleton-item-".concat(i);
    if (typeof isLoading !== 'undefined') {
      var completePropsNew = _objectSpread(_objectSpread({}, completeProps), {}, {
        className: getLoadingClassName(className, isLoading)
      });
      skeletonArr.push(/*#__PURE__*/React__default.createElement(skeleton_style.StyledBaseSkeleton, _extends({}, completePropsNew, {
        key: skeletonItemId
      }), /*#__PURE__*/React__default.createElement("span", null, children)));
    } else {
      skeletonArr.push(/*#__PURE__*/React__default.createElement(skeleton_style.StyledBaseSkeleton, _extends({}, completeProps, {
        key: skeletonItemId
      })));
    }
  }
  return /*#__PURE__*/React__default.createElement(React.Fragment, null, skeletonArr);
};
const Skeleton$1 = styled.withTheme(Skeleton);

module.exports = Skeleton$1;
